<div class="tse">
  <button type="button" class="tse-trigger" *ngIf="!compact" (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen" aria-haspopup="menu">
    <i class="ri-file-excel-line" aria-hidden="true"></i> Export
    <i class="ri-arrow-down-s-line tse-caret" [class.open]="menuOpen" aria-hidden="true"></i>
  </button>
  <button type="button" class="tse-trigger compact" *ngIf="compact" (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen" aria-haspopup="menu" aria-label="Export this view"
    [pTooltip]="menuOpen ? '' : 'Export this view'" tooltipPosition="top">
    <i class="ri-file-excel-line" aria-hidden="true"></i>
  </button>

  <div class="tse-menu" role="menu" *ngIf="menuOpen">
    <button type="button" role="menuitem" (click)="choose('pdf')">
      <span class="tse-ic pdf">PDF</span>
      <span><b>Export as PDF</b><small>Printable timesheet</small></span>
    </button>
    <button type="button" role="menuitem" (click)="choose('xlsx')">
      <span class="tse-ic xls">XLS</span>
      <span><b>Export as Excel</b><small>Editable .xlsx sheet</small></span>
    </button>
  </div>
</div>

<!-- Popup: indigo summary panel on the left, the form on the right. -->
<p-dialog [(visible)]="dialogOpen" [modal]="true" appendTo="body" [baseZIndex]="baseZIndex" [draggable]="false"
  [resizable]="false" [showHeader]="false" [closable]="!exporting" [closeOnEscape]="!exporting"
  [dismissableMask]="!exporting" [style]="{ width: '780px' }" [breakpoints]="{ '820px': '96vw' }"
  styleClass="tse-dialog" (onShow)="raiseToasts(true)" (onHide)="raiseToasts(false)">
  <div class="tse-shell">
    <aside class="tse-rail">
      <div class="tse-brand">PMT<span>+</span></div>
      <div>
        <h3 class="tse-heading" id="tse-heading">Export Time Logs</h3>
        <p class="tse-sub">{{ showProjects ? 'Pick the period, projects, type and members.' : 'Pick the period, type and members.' }} The file downloads straight away.</p>
      </div>
      <span class="tse-ic sm on-rail" [class.pdf]="format === 'pdf'" [class.xls]="format === 'xlsx'">
        {{ format === 'pdf' ? 'PDF' : 'XLS' }}
      </span>

      <dl class="tse-sum">
        <div *ngIf="projectId">
          <dt>Project</dt>
          <dd>{{ projectName || 'This project' }}</dd>
        </div>
        <div>
          <dt>Time Period</dt>
          <dd>{{ periodSummary }}</dd>
        </div>
        <div *ngIf="showProjects">
          <dt>Projects</dt>
          <dd>{{ projectsSummary }}</dd>
        </div>
        <div>
          <dt>Time Log Type</dt>
          <dd><span class="tse-dot" [ngClass]="billableOption.tone" aria-hidden="true"></span>{{ billableOption.label }}</dd>
        </div>
        <div>
          <dt>Members</dt>
          <dd>{{ membersSummary }}</dd>
        </div>
        <div *ngIf="fileName">
          <dt>File</dt>
          <dd class="file">{{ fileName }}</dd>
        </div>
      </dl>
    </aside>

    <div class="tse-main" role="group" aria-labelledby="tse-heading">
      <button type="button" class="tse-close" (click)="closeDialog()" [disabled]="exporting" aria-label="Close">
        <i class="ri-close-line" aria-hidden="true"></i>
      </button>

      <div class="tse-field" *ngIf="projectId">
        <span class="tse-label"><i class="ri-folder-line" aria-hidden="true"></i>Project</span>
        <div class="tse-project">
          <span class="name">{{ projectName || 'This project' }}</span>
          <small>Fixed for this export</small>
        </div>
      </div>

      <div class="tse-field">
        <span class="tse-label" id="tse-format-label"><i class="ri-file-list-3-line" aria-hidden="true"></i>File Format</span>
        <div class="tse-fmt" role="group" aria-labelledby="tse-format-label">
          <button type="button" *ngFor="let f of formatOptions" [attr.aria-pressed]="format === f.value"
            (click)="setFormat(f.value)" [disabled]="exporting">
            <span class="tse-ic" [class.pdf]="f.value === 'pdf'" [class.xls]="f.value === 'xlsx'">{{ f.badge }}</span>
            <span class="txt"><b>{{ f.label }}</b><small>{{ f.hint }}</small></span>
            <span class="ck" aria-hidden="true"><i class="ri-check-line"></i></span>
          </button>
        </div>
      </div>

      <div class="tse-field">
        <span class="tse-label" id="tse-period-label"><i class="ri-calendar-line" aria-hidden="true"></i>Time Period</span>
        <div class="tse-seg" role="group" aria-labelledby="tse-period-label">
          <button type="button" [attr.aria-pressed]="period === 'current'" (click)="setPeriod('current')">Current month</button>
          <button type="button" [attr.aria-pressed]="period === 'month'" (click)="setPeriod('month')">Month</button>
          <button type="button" [attr.aria-pressed]="period === 'range'" (click)="setPeriod('range')">Date range</button>
        </div>

        <!-- Floating panels are attached to <body>; "resize-safe" stops the project
             sidebar (app-resizable) from treating a click in them as an outside click. -->
        <p-calendar *ngIf="period === 'month'" inputId="tse-month" [(ngModel)]="pickedMonth" view="month"
          dateFormat="MM yy" [readonlyInput]="true" [showIcon]="true" appendTo="body" styleClass="tse-cal"
          panelStyleClass="resize-safe" placeholder="Choose a month" (onSelect)="onScopeChange()"></p-calendar>

        <p-calendar *ngIf="period === 'range'" inputId="tse-range" [(ngModel)]="range" selectionMode="range"
          dateFormat="dd-mm-yy" [readonlyInput]="true" [showIcon]="true" appendTo="body" styleClass="tse-cal"
          panelStyleClass="resize-safe" placeholder="Start date – end date" (onSelect)="onScopeChange()"></p-calendar>

        <span class="tse-hint">{{ periodHint }}</span>
      </div>

      <!-- Projects filter: Time Logs page only (the sidebar export is fixed to its project). -->
      <div class="tse-field" *ngIf="showProjects">
        <label class="tse-label" for="tse-projects"><i class="ri-folder-line" aria-hidden="true"></i>Projects</label>
        <p-multiSelect inputId="tse-projects" [options]="projectOptions" [(ngModel)]="projectIds" optionLabel="name"
          optionValue="_id" [filter]="true" filterBy="name" placeholder="All projects" display="chip"
          [maxSelectedLabels]="3" selectedItemsLabel="{0} projects selected" appendTo="body" styleClass="tse-select"
          panelStyleClass="resize-safe" (onChange)="onScopeChange()" [disabled]="exporting"></p-multiSelect>
        <span class="tse-hint">Leave empty to include every project.</span>
      </div>

      <div class="tse-field">
        <label class="tse-label" for="tse-billable"><i class="ri-price-tag-3-line" aria-hidden="true"></i>Time Log Type</label>
        <p-dropdown inputId="tse-billable" [options]="billableOptions" [(ngModel)]="billable" optionLabel="label"
          optionValue="value" appendTo="body" styleClass="tse-select" panelStyleClass="tse-type-panel resize-safe">
          <ng-template pTemplate="selectedItem">
            <span class="tse-type-sel">
              <span class="tse-dot" [ngClass]="billableOption.tone" aria-hidden="true"></span>{{ billableOption.label }}
            </span>
          </ng-template>
          <ng-template let-opt pTemplate="item">
            <span class="tse-type-item">
              <span class="tse-dot" [ngClass]="opt.tone" aria-hidden="true"></span>
              <span><b>{{ opt.label }}</b><small>{{ opt.hint }}</small></span>
            </span>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="tse-field">
        <label class="tse-label" for="tse-members"><i class="ri-team-line" aria-hidden="true"></i>Members</label>
        <p-multiSelect inputId="tse-members" [options]="memberOptions" [(ngModel)]="memberIds" optionLabel="label"
          optionValue="_id" [filter]="true" filterBy="label,firstName,lastName,email" [placeholder]="allMembersLabel"
          display="chip" [maxSelectedLabels]="4" selectedItemsLabel="{0} members selected" appendTo="body"
          [disabled]="!privileged" styleClass="tse-select" panelStyleClass="resize-safe"></p-multiSelect>
        <span class="tse-hint" *ngIf="privileged && !projectId && !projectIds.length">Leave empty to export every member.</span>
        <span class="tse-hint" *ngIf="privileged && !projectId && projectIds.length">{{ projectMembersHint }}</span>
        <span class="tse-hint tse-note" *ngIf="memberNote">{{ memberNote }}</span>
        <span class="tse-hint" *ngIf="privileged && projectId">Leave empty to include everyone who logged time on this project in the period.</span>
        <span class="tse-hint" *ngIf="!privileged">You can export your own time logs.</span>
      </div>

      <div class="tse-foot">
        <button type="button" class="tse-btn ghost" (click)="closeDialog()" [disabled]="exporting">Cancel</button>
        <button type="button" class="tse-btn primary" (click)="export()" [disabled]="!canExport">
          <i class="ri-download-2-line" aria-hidden="true" *ngIf="!exporting"></i>
          {{ exporting ? 'Preparing…' : 'Export ' + formatLabel }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
